import { render, staticRenderFns } from "./BusinessDetails.vue?vue&type=template&id=8fda4966&scoped=true"
import script from "./BusinessDetails.vue?vue&type=script&lang=ts"
export * from "./BusinessDetails.vue?vue&type=script&lang=ts"
import style0 from "./BusinessDetails.vue?vue&type=style&index=0&id=8fda4966&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fda4966",
  null
  
)

export default component.exports